import React, { useState } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  TextField,
  Grid,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Typography
} from '@mui/material';

export const EditOrderForm = ({ order, open, onClose, onSave, branches, places }) => {
  const [formData, setFormData] = useState({
    saleOrderId: order?.saleOrderId || '',
    customerName: order?.customerName || '',
    customerAddress: order?.customerAddress || '',
    mobile: order?.mobile || '',
    deliveryScheduleDate: order?.deliveryScheduleDate || '',
    timeSlotName: order?.timeSlotName || '',
    pincode: order?.pincode || '',
    placeName: order?.placeName || '',
    delBranchID: order?.delBranchID || '',
    placeId: order?.placeId || ''
  });

  const handleChange = (field) => (event) => {
    setFormData(prev => ({
      ...prev,
      [field]: event.target.value
    }));
  };

  const handleSubmit = () => {
    onSave(formData);
    onClose();
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth>
      <DialogTitle>
        <Typography variant="h6">Edit Order Details</Typography>
      </DialogTitle>
      <DialogContent>
        <Grid container spacing={2} sx={{ mt: 1 }}>
          <Grid item xs={12} md={6}>
            <TextField
              fullWidth
              label="Order ID"
              value={formData.saleOrderId}
              disabled
              variant="outlined"
              margin="dense"
            />
          </Grid>
          <Grid item xs={12} md={6}>
            <TextField
              fullWidth
              label="Customer Name"
              value={formData.customerName}
              onChange={handleChange('customerName')}
              variant="outlined"
              margin="dense"
            />
          </Grid>
          <Grid item xs={12}>
            <TextField
              fullWidth
              label="Address"
              value={formData.customerAddress}
              onChange={handleChange('customerAddress')}
              multiline
              rows={3}
              variant="outlined"
              margin="dense"
            />
          </Grid>
          <Grid item xs={12} md={6}>
            <TextField
              fullWidth
              label="Mobile Number"
              value={formData.mobile}
              onChange={handleChange('mobile')}
              variant="outlined"
              margin="dense"
            />
          </Grid>
          <Grid item xs={12} md={6}>
            <TextField
              fullWidth
              type="date"
              label="Delivery Schedule Date"
              value={formData.deliveryScheduleDate}
              onChange={handleChange('deliveryScheduleDate')}
              variant="outlined"
              margin="dense"
              InputLabelProps={{ shrink: true }}
            />
          </Grid>
          <Grid item xs={12} md={6}>
            <TextField
              fullWidth
              label="Time Slot"
              value={formData.timeSlotName}
              onChange={handleChange('timeSlotName')}
              variant="outlined"
              margin="dense"
            />
          </Grid>
          <Grid item xs={12} md={6}>
            <TextField
              fullWidth
              label="Pincode"
              value={formData.pincode}
              onChange={handleChange('pincode')}
              variant="outlined"
              margin="dense"
            />
          </Grid>
          <Grid item xs={12} md={6}>
            <FormControl fullWidth variant="outlined" margin="dense">
              <InputLabel>Branch</InputLabel>
              <Select
                value={formData.delBranchID}
                onChange={handleChange('delBranchID')}
                label="Branch"
              >
                {branches.map((branch) => (
                  <MenuItem key={branch.branchID} value={branch.branchID}>
                    {branch.branchName}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Grid>
          <Grid item xs={12} md={6}>
            <FormControl fullWidth variant="outlined" margin="dense">
              <InputLabel>Place</InputLabel>
              <Select
                value={formData.placeId}
                onChange={handleChange('placeId')}
                label="Place"
              >
                {places[formData.pincode]?.map((place) => (
                  <MenuItem key={place.placeId} value={place.placeId}>
                    {place.placeName}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Grid>
        </Grid>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} color="secondary">
          Cancel
        </Button>
        <Button onClick={handleSubmit} color="primary" variant="contained">
          Save Changes
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default EditOrderForm;